module.exports = __webpack_public_path__ + "static/Gilroy-SemiBold-99fc0857b59954d9c5a26a10ebed3644.woff2";